import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SideBarMenu } from 'src/app/shared/global/sidebarMenu';
import { UserService } from 'src/app/core/services/user/user.service';
import { AyenServices } from 'src/app/core/services/ayen-services/ayen-services.service';
import { FeatureFlagConstant } from 'src/app/shared/global/featuerFlag-contstant';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  ordersCount;
  sidebarstatus;
  isChild: boolean = false;
  sidebarMenu: any = [];
  showMenu: boolean = false;
  dropdowns: any = {};
  sidebarOpen = false;

  constructor(
    private router: Router,
    private titleService: Title,
    private ayenServices: AyenServices,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    const userType = this.userService.userType;
    if (userType) {
      this.sidebarMenu = SideBarMenu.SIDEBAR_MENU_DATA[userType] || [];
    } else {
      this.sidebarMenu = [];
    }
    this.dropdowns = { ...SideBarMenu.DROPDOWNS };
    this.activeSideItem();
    this.setupFeatureFlagSubscription();
  }

  private applyFeatureFlags(): void {
    if (!this.sidebarMenu || !Array.isArray(this.sidebarMenu)) {
      return;
    }
    
    // Filter menu items based on feature flags
    this.sidebarMenu = this.sidebarMenu.filter((menu) => {
      // If no feature flag is defined, show the menu
      if (!menu.featureFlag) {
        return true;
      }
      // If feature flag is defined, only show if enabled
      return this.ayenServices.isFeatureEnabled(menu.featureFlag);
    }).map((menu) => ({
      ...menu,
      subMenuItems: menu.subMenuItems ? [...menu.subMenuItems] : [],
    }));
  }

  setupFeatureFlagSubscription() {
    this.ayenServices.featureFlags$.subscribe({
      next: (data) => {
        if (!data) {
          return;
        }

        this.applyFeatureFlags();
        this.activeSideItem();
      },
    });
  }

  checkMenu(name) {
    if (this.router.url.includes(name)) {
      return true;
    }
  }

  setStatus(status, title, isChild?) {
    this.sidebarstatus = status;
    this.titleService.setTitle(title);
    this.isChild = isChild ? isChild : false;
  }

  toggleSubMenu(name) {
    this.dropdowns[name] = !this.dropdowns[name];
  }

  clickItem(status, title, path, hideSubMenu) {
    this.sidebarstatus = status;
    this.titleService.setTitle(title);
    this.router.navigateByUrl(path);
    if (hideSubMenu) {
      Object.keys(this.dropdowns).forEach((item) => {
        this.dropdowns[item] = false;
      });
    }
  }
  activeSideItem() {
    if (!this.sidebarMenu || !Array.isArray(this.sidebarMenu)) {
      return;
    }
    
    this.sidebarMenu.forEach((item) => {
      if (item.isSubMenu) {
        item.subMenuItems.forEach((subItem) => {
          if (this.router.url === subItem.url) {
            this.dropdowns[item.sidebarstatus] = true;
            this.setStatus(subItem.sidebarstatus, subItem.pageTile, true);
          }
        });
      } else {
        if (this.router.url === item.url) {
          this.setStatus(item.sidebarstatus, item.pageTile);
        }
      }
    });
  }

  logout() {
    this.userService.clearAll();
    this.router.navigateByUrl('/auth/login');
  }
}
